import React from 'react';
export const PrivacyPolicy = () => {
  return <div className="text-gray-700" data-id="element-132">
      <p className="mb-4" data-id="element-133">
        <strong data-id="element-134">Last Updated:</strong> September 1, 2025
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-135">1. Introduction</h4>
      <p className="mb-4" data-id="element-136">
        The Legacy #7 Collector's Edition ("we," "our," or "us") is committed to
        protecting your privacy. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you purchase our
        collector's edition book or visit our website.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-137">2. Information We Collect</h4>
      <p className="mb-4" data-id="element-138">
        We may collect personal information that you voluntarily provide when
        placing an order, including name, email address, shipping address, and
        payment information. We also automatically collect certain information
        about your device and how you interact with our website.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-139">
        3. How We Use Your Information
      </h4>
      <p className="mb-4" data-id="element-140">
        We use the information we collect to process your order, communicate
        with you, improve our services, and comply with legal obligations. We
        may also use your information to send you promotional communications
        about special offers or new products, subject to your right to opt-out.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-141">
        4. Sharing Your Information
      </h4>
      <p className="mb-4" data-id="element-142">
        We may share your information with third-party service providers who
        help us with order fulfillment, payment processing, and shipping. We do
        not sell your personal information to third parties.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-143">5. Security</h4>
      <p className="mb-4" data-id="element-144">
        We implement reasonable security measures to protect your personal
        information from unauthorized access, disclosure, or destruction.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-145">6. Your Rights</h4>
      <p className="mb-4" data-id="element-146">
        Depending on your location, you may have the right to access, correct,
        or delete your personal information. To exercise these rights, please
        contact us using the information provided below.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-147">
        7. Changes to This Privacy Policy
      </h4>
      <p className="mb-4" data-id="element-148">
        We may update this Privacy Policy from time to time. The updated version
        will be indicated by an updated "Last Updated" date.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-149">8. Contact Us</h4>
      <p className="mb-4" data-id="element-150">
        If you have questions or concerns about this Privacy Policy, please
        contact us at privacy@legacy7edition.com.
      </p>
    </div>;
};